export interface ICalculate {
	submittedZero?: number;
	submittedMiddle?: number;
	submittedHigh?: number;
}
export interface ICalculated {
	submitted: number;
	nonZeroSubmitted: number;
	satisfaction: number | null;
}

export function calculateSubmittedAndSatisfaction<T>(
	data: T & ICalculate,
): T & ICalculated & ICalculate {
	const { submittedZero = 0, submittedMiddle = 0, submittedHigh = 0 } = data;

	const satisfaction =
		!submittedMiddle && !submittedHigh && submittedZero
			? null
			: Math.round((submittedHigh / (submittedMiddle + submittedHigh)) * 100);

	return {
		...data,
		submitted: submittedZero + submittedMiddle + submittedHigh,
		nonZeroSubmitted: submittedMiddle + submittedHigh,
		satisfaction,
	};
}
